export default "__VITE_PUBLIC_ASSET__9e7b0f8a__"